module.exports = __webpack_public_path__ + "static/2-c216c332e4ce0e44ecbc0679de7e8a65.png";